import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../../../../components/Modal';
import Block from './Block';

import './Add-Cart.scss';

const AddToCartModal = (props) => {
  const {
    isShow,
    hideModal,
    tourForCart,
    addToCart,
    cities,
  } = props;

  const getStaffPrice = () => {
    if(cities && cities.length && tourForCart){
      const {cityId} = tourForCart;
      for(let i = 0; i < cities.length; i++){
        if(cities[i].id === cityId){
          return cities[i].staffPrice;
        }
      }
    }
    return null;
  };

  return (
    <Modal
      classModal="cart"
      isOpen={isShow}
      onRequestClose={hideModal}
      showCloseIcon
      shouldCloseOnOverlayClick={false}
    >
      <Block
        {...tourForCart}
        addToCart={addToCart}
        staffPrice={getStaffPrice()}
      />
    </Modal>
  )
};

AddToCartModal.propTypes = {
  isShow: PropTypes.bool,
  hideModal: PropTypes.func,
  tourForCart: PropTypes.object,
  addToCart: PropTypes.func,
  cities: PropTypes.array,
};

export default connect(s=>({cities: s.main.cities}), null)(AddToCartModal);


// WEBPACK FOOTER //
// ./src/app/containers/TourPage/components/AddToCart/index.js